'use strict';

/* eslint global-require: 0 */

require('airbnb-js-shims');

require('./browser-only');



//////////////////
// WEBPACK FOOTER
// ../node_modules/airbnb-browser-shims/index.js
// module id = 457
// module chunks = 0